// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ess: "https://ess.aapico.com",
  // server: "http://agrappl03.aapico.com:1339",
  // server:
  //   window.location.origin.split(":")[0] +
  //   ":" +
  //   window.location.origin.sp2lit(":")[1] +
  //   ":1337",
  // version: "v4.0.10",
  //server: "http://localhost:1337",
  server: "https://ahp-backend-1082888066140.asia-east1.run.app",
  // server: "https://ahp-backend-yrl362wd5a-de.a.run.app:1339",
  // server: 'http://192.168.2.37:1337'
  orgServer: "http://agrflow01.aapico.com:1337",
  status_revise: {
    ADD: "1",
    EDIT: "2",
    DELETE: "3",
  },
};
